import React from "react";
import { Text, View } from "native-base";
import FastImage from "@d11/react-native-fast-image";
import OstatkiDisplay from "../../../../UnitFull/OstatkiDisplay/OstatkiDisplay";
import { useAppContext } from "../../../../Universal/API/Context-API/AppContext";
import PressableWrapp from "../../../../Universal/Buttons/PressableReact/PressableWrapp";
import CarouselImages from "../../../../Universal/CarouselImages/CarouselImages";
import {
  getGalleryCount,
  getPrimaryImage,
} from "../helpers";
import { UnitCardMediaProps } from "../types";

const UnitCardMedia: React.FC<UnitCardMediaProps> = ({
  item,
  artLabel,
  collectionLabel,
  mediaEnabled,
  mediaHeight,
  carouselWidth,
  styles,
  onCopyArt,
}) => {
  const { isSmallVersion, scaleAll } = useAppContext();
  const primaryImage = getPrimaryImage(item);
  const galleryCount = getGalleryCount(item);
  const sliderImages = item.unit.sliders?.medium ?? [];

  return (
    <View
      style={[
        styles.mediaShell,
        isSmallVersion ? styles.mediaShellSmall : null,
      ]}
    >
      <View style={styles.mediaTopRow}>
        {collectionLabel ? (
          <View style={[styles.collectionChip, isSmallVersion ? styles.collectionChipSmall : null]}>
            <Text
              style={[styles.collectionChipText, isSmallVersion ? styles.collectionChipTextSmall : null]}
              numberOfLines={1}
            >
              {collectionLabel}
            </Text>
          </View>
        ) : (
          <View />
        )}

        {galleryCount > 1 ? (
          <View style={[styles.galleryCountPill, isSmallVersion ? styles.galleryCountPillSmall : null]}>
            <Text style={[styles.galleryCountText, isSmallVersion ? styles.galleryCountTextSmall : null]}>
              {galleryCount} фото
            </Text>
          </View>
        ) : null}
      </View>

      <View style={styles.mediaCenter}>
        {mediaEnabled && primaryImage ? (
          sliderImages.length > 1 ? (
            <CarouselImages
              data={sliderImages}
              width={carouselWidth}
              height={mediaHeight}
              addPagination={true}
              carouselProps={{
                loop: true,
                windowSize: 1,
              }}
              renderItem={({ item: image }) => (
                <View style={styles.mediaViewport}>
                  <View
                    style={[
                      styles.mediaImageFrame,
                      isSmallVersion ? styles.mediaImageFrameSmall : null,
                    ]}
                  >
                    <FastImage
                      source={{ uri: image }}
                      style={styles.mediaImage}
                      resizeMode="contain"
                    />
                  </View>
                </View>
              )}
            />
          ) : (
            <View style={styles.mediaViewport}>
              <View
                style={[
                  styles.mediaImageFrame,
                  isSmallVersion ? styles.mediaImageFrameSmall : null,
                ]}
              >
                <FastImage
                  source={{ uri: primaryImage }}
                  style={styles.mediaImage}
                  resizeMode="contain"
                />
              </View>
            </View>
          )
        ) : (
          <View style={styles.mediaPlaceholder} />
        )}
      </View>

      <View style={styles.mediaHintRow}>
        {artLabel ? (
          <PressableWrapp onPress={onCopyArt} style={[styles.artPill, isSmallVersion ? styles.artPillSmall : null]}>
            <Text style={[styles.artPillText, isSmallVersion ? styles.artPillTextSmall : null]}>{artLabel}</Text>
          </PressableWrapp>
        ) : (
          <View />
        )}

        <OstatkiDisplay compact={true} unit={item.unit} scaleAll={scaleAll} />
      </View>
    </View>
  );
};

export default React.memo(UnitCardMedia);
